// extracted by mini-css-extract-plugin
export var numpadContainer = "_oo-1";
export var phoneButton = "_oo-0";